import { render, staticRenderFns } from "./incomeStockMovementTransferBox.vue?vue&type=template&id=abeba9d0&"
import script from "./incomeStockMovementTransferBox.vue?vue&type=script&lang=ts&"
export * from "./incomeStockMovementTransferBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports